import { NavigationMenu } from "components/NavigationMenu";
import styled from "styled-components/macro";
import type { ElearningTheme } from "themes/elearning.theme";

interface Props {
  theme: ElearningTheme;
}

export const StyleContent = styled.div<Props>`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  justify-content: space-between;
  z-index: 300;
  border-radius: 4px;
  box-shadow: 0 0 8px rgba(70, 82, 129, 0.13);
  width: 264px;
  margin-top: 2.5rem;
  background-color: ${(props: Props) => props.theme.palette.neutral.white};
  a {
    text-decoration: none;
    color: ${(props: Props) => props.theme.palette.neutral.black};
  }
`;

export const StyleRow = styled.div<Props>`
  padding: 10px 15px;
  cursor: pointer;
  background-color: ${(props: Props) => props.theme.palette.neutral.white};
  &:hover {
    background-color: ${(props: Props) => props.theme.palette.neutral._100};
  }
`;

export const StyledMenu = styled(NavigationMenu)<Props>`
  margin-left: 24px;
`;
